switch (process.env.ENV_TAREGT) {  
    case 'dev_test':
        global.LoginPath = 'https://www.weixiaojia.net/wxcepClient1/';
        global.BasePath = 'https://www.weixiaojia.net/wxcepClient1/';
        command = 'dev_test';
        break;
    case 'build_test':
        global.LoginPath = 'https://www.weixiaojia.net/wxcepClient1/';
        global.BasePath = 'https://www.weixiaojia.net/wxcepClient1/';
        command = 'build_test';
        break;
    case 'production':
        global.LoginPath = 'https://www.zhxiaoyuan.cn/wxcepClient1/';
        global.BasePath = 'https://www.zhxiaoyuan.cn/wxcepClient1/';
        command = 'production';
        break;
}



// WEBPACK FOOTER //
// ./src/utils/initEnv.js